import { request } from '@utils';

const getSellVehiclesB2B = async ({ params = {}, payload = {} }) => {
  const body = {
    body: payload,
  };
  const results = await request.post(
    `/v1/b2b/vehicle-sales/filter?${new URLSearchParams(params)}`,
    body
  );

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const addServiceVehiclesB2B = async (payload) => {
  const params = {
    body: payload,
  };
  const results = await request.post(`/v1/b2b/vehicle-sales`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};

const editServiceVehiclesB2B = async (id, payload) => {
  const params = {
    body: payload,
  };
  const results = await request.patch(`/v1/b2b/vehicle-sales/${id}`, params);

  if (results?.error) {
    return Promise.reject(results?.message);
  }

  return results;
};
export { getSellVehiclesB2B, addServiceVehiclesB2B, editServiceVehiclesB2B };
